import { useState } from "react";
import { addMovieToList } from '../../firebase';

export default function AddMovieModal({ isOpen, onClose, user, listId }) {
  const [movieName, setMovieName] = useState('');

  if (!isOpen) return null; // Don’t render if closed

  const handleSubmit = (e) => {
    e.preventDefault();

    if (movieName.trim().length < 2) {
      console.log("Needs more characters!");
    } else {
      const movieData = {
        movieName: movieName,
        submittedName: user.currentUser.name
      }
  
      addMovieToList(listId, movieData);
      setMovieName('');
      onClose();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2 className='item-title'>Movie Name</h2>
        <form onSubmit={handleSubmit}>
          <div className="add-movie-form">
            <label></label>
            <input className='movie-input'
              name='movieName' 
              value={movieName}
              onChange={(e) => {setMovieName(e.target.value)}}
	      autoFocus
            />
          </div>

          <div className="modal-actions">
            <button className="mainPageButtons" type="submit">Add</button>
            <button className="mainPageButtons" type="button" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
